var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Carousel'),_c('PopularProducts'),_c('UseScene'),_c('div',{staticClass:"bg"},[_c('OurAdvantage'),_c('UserEvaluation')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }